import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SelectionStateService } from 'src/app/services/selection-state.service';
import { FirebaseMessagingService } from 'src/app/services/firebase-messaging.service';
import { Capacitor } from '@capacitor/core';
import { USER_ROLE } from 'src/app/types/user-role.types';
import { APP_ROUTES } from 'src/app/types/app-routes';
import { RoleNavigationService } from 'src/app/services/role-navigation.service';

@Component({
  selector: 'app-redirecting',
  template: '',
  standalone: false
})
export class RedirectingComponent implements OnInit {

  constructor(
    private readonly _selectionState: SelectionStateService,
    private readonly _router: Router,
    private readonly _fcmService: FirebaseMessagingService,
    private readonly _roleNavigation: RoleNavigationService,
  ) { }

  async ngOnInit() {
    await this._selectionState.initialize(); 
    
    if (Capacitor.isNativePlatform()) {
      const notificationProcessed = await this._fcmService.waitForInitialNotificationProcessing(2000);
      
      if (notificationProcessed) {
        return;
      }
    }
    
    this._router.navigate([this.destination()]);
  }

  /** Los `sellers` van siempre al dashboard; el resto, al inicio de su rol o a login si no tiene. */
  private destination(): string {
    const hasNoRole = this._selectionState.getSelectedRoleValue() === USER_ROLE.UNKNOWN;
    if (!this._selectionState.isSellersUser() && hasNoRole) {
      return APP_ROUTES.LOGIN;
    }
    return this._roleNavigation.landingRoute();
  }
}
